import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, TableCell, Chip} from '@material-ui/core'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { Datatable, DatatableToolbar, DatatableHead, DatatableBody } from 'src/shared/Datatable'
import DatatableFilters from 'src/shared/Datatable/Filters/DatatableFilters'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { CotationCriteria } from 'src/type/criteria/cotationCriteria'
import { fetchCotations } from 'src/core/redux/action/cotationsAction'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import { TableSortCell } from 'src/shared/TableSort'
import DatatableRow from 'src/shared/Datatable/DatatableRow'
import { ICotation } from 'src/type/cotation'
import DatatableFilterCustomArray from 'src/shared/Datatable/Filters/DatatableFilterMultipleCustomArray'
import CotationsCellAction from 'src/page/Consumer/Cotations/CotationsCellAction'
import DatatableFilterMultipleCustomArray from 'src/shared/Datatable/Filters/DatatableFilterMultipleCustomArray'
import Alert from 'src/shared/Alert/Alert'
import { UtilsAction } from 'src/core/redux/action/utilsAction'
import { replaceDetteWithTaux } from 'src/shared/utils/helpers'


const styles = (t: Theme) => createStyles({
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    tableWpr: {
        width: '100%',
        overflow: 'auto'
    }
});

const paginateName = 'cotations';
const paginateAction = fetchCotations;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithGlobalProgress,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
    status: string;
    refeshAfterChange: () => void;
}

interface IStates {
}

class CotationsTable extends React.Component<IProps, IStates> {
    state = {
        selectedRow: [] as number[]
    }


  render(){
    const { t, classes, productTypes, status, criteria } = this.props;
    return(
        <div className={classes.tableWpr}>
            {status === "LIVE" &&
                <>
                    <Alert type="info">{t.Cotation_table_warning}</Alert>
                    <br/>
                </>
            }
            <Datatable
                name={paginateName}
                action={paginateAction}
                criteriaDefault={{status, sort_by: "last_updated_at", order_by: "desc", limit: criteria.limit, offset: criteria.offset}}
                isExpendRow={false}
            >
                <DatatableFilters>
                    <DatatableFilterCustomArray
                        display="Métier SDM"
                        filterBy="category_principale"
                        items={[
                            {label: 'Change', value: 'change'},
                            {label: 'Taux', value: 'dette'},
                            {label: 'Placement', value: 'placement'}
                        ]}
                    />
                    {productTypes &&
                        <DatatableFilterMultipleCustomArray
                            display="Type de produit"
                            filterBy="product_type"
                            items={productTypes}
                        />
                    }
                    <DatatableFilterMultipleCustomArray
                        display="Attribution"
                        filterBy="assigned_to"
                        items={[
                            {label: 'Client', value: 'client'},
                            {label: 'ARKEA', value: 'arkea'}
                        ]}
                    />
                </DatatableFilters>

                <DatatableToolbar 
                    search="global_search"
                />
                
                <DatatableHead>
                    <TableSortCell name="created_at">{t.Cotation_table_column_created_at}</TableSortCell>
                    <TableSortCell name="last_updated_at">{t.Cotation_table_column_last_update_at}</TableSortCell>
                    <TableSortCell name="name">{t.Cotation_table_column_name}</TableSortCell>
                    <TableCell>{t.Cotation_table_column_assignment}</TableCell>
                    <TableCell>{t.Cotation_table_column_category_of_product}</TableCell>
                    <TableCell>{t.actions}</TableCell>
                </DatatableHead>

                <DatatableBody renderRow={this.renderRow}/>
            </Datatable>
        </div>
    )
  }

    @autobind
    private renderRow(s: ICotation) {
        const {formatDate, mapName, classes, status, refeshAfterChange} = this.props
        return (
                <DatatableRow >
                    <TableCell style={{maxWidth: 100}}>{formatDate(s.created_at)}</TableCell>
                    <TableCell style={{maxWidth: 100}}>{s.last_updated_at ? formatDate(s.last_updated_at) : '-'}</TableCell>
                    <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>{s.name}</TableCell>
                    <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>{this.assignRender(s.assigned_to)}</TableCell>
                    <TableCell>
                        {s.category_principale && s.category_principale.length > 0 &&
                            s.category_principale.split(",").map(c => 
                                mapName.get(c) !== undefined ? <Chip key={`${s.id}-category-principale-${s.id}`} label={replaceDetteWithTaux(mapName.get(c))} className={classes.chip}/> : ''
                            )
                        }
                    </TableCell>
                    <TableCell>
                        <CotationsCellAction entity={s} {...{status, refeshAfterChange}}/>
                    </TableCell>
                </DatatableRow>
        )
    }

    componentDidMount(){
        const { status } = this.props
        this.props.resetCriteriaByObject({status, sort_by: "last_updated_at", order_by: "desc", limit: 10, offset: 0})
        this.props.fetchMapProductType()
    } 

    @autobind
    private assignRender(assign: string){
        const {t} = this.props;
        return ({
            arkea: t.arkea,
            client: t.client
        } [ assign ] || "")
    }

}

const state2props = (state: RootState) => ({
    connectedUser: state.accountInfo.connectedUser,
    enterprise: state.accountInfo.enterpriseSelected,
    criteria: state.paginate.cotations.criteria,
    cotations: state.paginate.cotations.entities,
    categories: state.categories.entities,
    mapName: state.utils.mapCategories,
    mapProductType: state.utils.mapProductType,
    productTypes: state.utils.productTypes,
});

const dispatch2props = dispatch => ({
    fetchMapProductType: () => dispatch(UtilsAction.initMapProductType()),
    fetchCotations: (criteria?: CotationCriteria) => dispatch(fetchCotations(criteria)),
    updateCriteriaByObject: (object: any) => dispatch(actions.updateCriteriaByObject(object)),
    resetCriteriaByObject: (object: any) => dispatch(actions.resetCriteriaByObject(object)),
});


export default compose(
  withI18n,
  withGlobalProgress,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(CotationsTable)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotations/CotationsTable.tsx